export const FILE_STATE = {
  TO_BE_SENT: 0,
  UNDER_REVIEW: 1,
  APPROVED: 2,
  REJECTED: 3,
  VERIFIED: 4,
};
